import {IAllocateAssetsFormData} from "../../types/asset.types";
import Locale from "../../../../core/locale/locale";
import dayjs from "dayjs";

export function allocateAssetModalMapper(data: IAllocateAssetsFormData) {
    return {
        categoryId: data.categoryId,
        assetId: data.assetId,
        expectedReturnDate: data.expectedReturnDate ? dayjs(data.expectedReturnDate).format(Locale.dateFormat) : "",
        adminRemarks: data.adminRemarks
    }
}